import { render, staticRenderFns } from "./UserGroupCustom.vue?vue&type=template&id=fa77c07e&scoped=true&"
import script from "./UserGroupCustom.vue?vue&type=script&lang=ts&"
export * from "./UserGroupCustom.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupCustom.vue?vue&type=style&index=0&id=fa77c07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa77c07e",
  null
  
)

export default component.exports